module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-month-10-d4d4c40c11e43179262bc82e27e21ad0.svg";